import React, { useEffect } from 'react';

export default function DisableDialog({ header, content, onClose, open }) {
    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose?.();
            }
        };

        window.addEventListener('keydown', handleEscape);

        return () => {
            window.removeEventListener('keydown', handleEscape);
        };
    }, [open, onClose]);

    if (!open) {
        return null;
    }

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose?.();
        }
    };

    return (
        <div
            className="disable__dialog"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-label={header || 'Dialog'}
        >
            <div className="pop__content">
                {header ? <p className="pop__headline">{header}</p> : null}
                {content ? <p className="pop__alert">{content}</p> : null}
                <div className="pop__btn_container">
                    <div></div>
                    <div className="btn close" onClick={onClose}>
                        close
                    </div>
                </div>
            </div>
        </div>
    );
}
